import { Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";

const SelectPeriode = ({ value, onChange, disabled }) => {
  const [listData, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const options = [
    {
      id: "TODAY",
      name: "Hari Ini",
    },
    {
      id: "THIS_WEEK",
      name: "Minggu Ini",
    },
    {
      id: "THIS_MONTH",
      name: "Bulan Ini",
    },
    {
      id: "THIS_YEAR",
      name: "Tahun Ini",
    },
  ];

  const getPeriode = async () => {
    setLoading(true);
    const newData = options;
    const filteredData = newData.filter(
      (item) => !listData.find((existingItem) => existingItem.id === item.id)
    );
    setData((prevData) => [...prevData, ...filteredData]);
    setLoading(false);
  };

  useEffect(() => {
    getPeriode();
  }, []);

  return (
    <Select
      style={{ width: "100%" }}
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder="Pilih Periode"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: e.name,
        value: e.id,
      }))}
      disabled={disabled}
    />
  );
};

export default SelectPeriode;
